import React from 'react';
import PartialCTA from '../partials/cta';

export function PricingTierField({
  standardPrice,
  volumePrice,
  cta_contact,
  cta_field,
  text,
  standardLimit,
  volumeLimit,
}: {
  standardPrice: number;
  volumePrice: number;
  cta_contact?: CtaField;
  cta_field?: CtaField;
  text?: any;
  standardLimit: number;
  volumeLimit: number;
}) {
  const aboveStandardLimit = standardPrice > standardLimit;
  const aboveVolumeLimit = volumePrice > volumeLimit;
  const aboveLimit = aboveStandardLimit || aboveVolumeLimit;

  return (
    <div className='pricing-fields'>
      <div className='pricing-fields__row apply-theme'>
        <div className='standard'>
          <span className='text'>Standard Tier: </span>
          <span className='arrow'></span>
          {aboveStandardLimit ? (
            <span className='pricing-total'>Send inquiry</span>
          ) : (
            <>
              <span className='pricing-total pricing-standard-total'>
                {`$${standardPrice}`}
              </span>
              <span className='month'>/month</span>
            </>
          )}
        </div>
        <div className='volume'>
          <span className='text'>Volume Tier: </span>
          <span className='arrow'></span>
          {aboveVolumeLimit ? (
            <span className='pricing-total'>Send inquiry</span>
          ) : (
            <>
              <span className='pricing-total pricing-volume-total'>
                {`$${volumePrice}`}
              </span>
              <span className='month'>/month</span>
            </>
          )}
        </div>
      </div>
      <div className='pricing-fields__row'>
        {aboveLimit && (
          <>
            {text && (
              <div
                className='text-formatted'
                dangerouslySetInnerHTML={{ __html: text }}
              ></div>
            )}
            {cta_contact && <PartialCTA data={cta_contact} />}
          </>
        )}
        {!aboveLimit && cta_field && <PartialCTA data={cta_field} />}
      </div>
    </div>
  );
}
